import { useState } from 'react';
import { basePort, headers, setCookie } from "../module_auth/AuthService"
import { useNavigate } from "react-router-dom";
import { ToastMessage } from "./common/Toast"

//url /mbr_cp_reg
export function MbrCpReg() {
    const [cpName, setCpName] = useState("");
    const [fullname, setFullname] = useState("");
    const [cpAddress, setCpAddress] = useState("");
    const [email, setEmail] = useState("");
    const [telno, setTelno] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [password, setPassword] = useState("");

    // 인사담당자정보
    const [recruiterName, setRecruiterName] = useState("");
    const [recruiterTelno, setRecruiterTelno] = useState("");
    const [recruiterEmail, setRecruiterEmail] = useState("");

    const [passwordRepeat, setPasswordRepeat] = useState("");
    const [allowRegister, setAllowRegister] = useState(false);
    
    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    //mbr role
    function handleCpName(event) {
        setCpName(event.target.value);
    }

    function handleFullname(event) {
        setFullname(event.target.value);
    }

    function handleEmail(event) {
        setEmail(event.target.value);
        setAllowRegister(false)
    }

    function handleMobileNo(event) {
        setMobileNo(event.target.value);
        setAllowRegister(false)
    }

    function handleTelno(event) {
        setTelno(event.target.value);
        setAllowRegister(false)
    }

    function handleCpAddress(event) {
        setCpAddress(event.target.value);
        setAllowRegister(false)
    }

    function handlePassword(event) {
        setPassword(event.target.value);
    }

    function handlePasswordRepeat(event) {
        setPasswordRepeat(event.target.value);
    }

    function handleRecruiterName(event) {
        setRecruiterName(event.target.value);
    }

    function handleRecruiterTelno(event) {
        setRecruiterTelno(event.target.value);
    }

    function handleRecruiterEmail(event) {
        setRecruiterEmail(event.target.value);
    }

    function clickSubmit(event) {
        event.preventDefault();
        fetch(basePort + '/authenticate/registration', 
            {method:'post', headers,
                      body:JSON.stringify({
                        email:email,
                        cpName:cpName,
                        cpAddress:cpAddress,
                        fullname:fullname,
                        telno:telno,
                        recruiterName:recruiterName,
                        recruiterTelno:recruiterTelno,
                        recruiterEmail:recruiterEmail,
                        plainPassword:password,
                        plainPasswordRepeat:passwordRepeat,
                        role:"TEMP_CP"
                    })})
                      .then(response => response.json())
                      .then(response => {
                        if(response.validRequest){
                            fadeOutToast(response.validationMessage)
                            //login()
                            validateMbr()
                        } else {
                            fadeOutToast(response.validationMessage)
                        }
            }).catch(error => console.log(error))

    }

    function validateMbr(){
        moveTo()
    }

    let navigate = useNavigate(); 
    function moveTo() {
        // let encodedEmail = window.btoa(email)
        // let encodedFullname = window.btoa(fullname)
        // let url = "/mbr_cp_reg_validation?id=" + encodedEmail + "&fullname=" + encodedFullname;
       
        //let url = "/mbr_cp_reg_validation?id=" + email + "&fullname=" + fullname;
        let url = "/mbr_cp_reg_validation?id=" + email;
        navigate(url);
    }

    function login(){
        const jwtRequest = {
            username:email,
            password:password,
        }
        fetch(basePort + '/authenticate', 
            {method:'post', headers, body:JSON.stringify(jwtRequest)})
                .then(response => response)
                .then(response => {
                if(response.jwtToken == null) {
                } else {
                    setCookie(response.jwtToken)
                    moveTo()
                }
            }).catch(error => console.log(error))
    }

    function doubleCheck(event) {
        event.preventDefault();
        fetch(basePort + '/checkEmail', 
            {method:'post', headers,
                      body:JSON.stringify({
                        cpName:cpName,
                        email:email,
                        fullname:fullname,
                        plainPassword:password,
                        plainPasswordRepeat:passwordRepeat,
                        role:"CP"
                    })})
                      .then(response => response.json())
                      .then(response => {
                        if(response.validRequest){
                            fadeOutToast(response.validationMessage)
                            setAllowRegister(true)
                        } else {
                            fadeOutToast(response.validationMessage)
                            setAllowRegister(false)
                        }
            }).catch(error => console.log(error))
    }

    function fadeOutToast(msg){
        setToastMessage(true, msg)
        setTimeout(function() {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }

    function setToastMessage(show, message){
        setShowToast(show)
        setMsgToast(message)
    }

    return (
        <div>
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <div class="row mb-5">
                        <div class="col-md-8 col-xl-6 text-center mx-auto">
                            <h2 style={{fontFamily: 'Nanum Gothic'}}>기업회원</h2>
                            <p></p>
                        </div>
                    </div>
                    <div class="row d-flex justify-content-center">
                        <div class="col-md-6 col-xl-4" style={{width: '600px'}}>
                            <div class="card mb-5">
                                <div class="card-body d-flex flex-column align-items-center">
                                    <form class="text-center" method="post" style={{width:'300px'}}>
                                        <div class="mb-3"><input class="form-control" type="email" name="email" placeholder="이메일(아이디)" onChange={handleEmail}/></div>
                                        {/* 회사 */}
                                        <div class="mb-3"><input class="form-control" type="text" placeholder="회사명" onChange={handleCpName}/></div>
                                        <div class="mb-3"><input class="form-control" type="text" placeholder="회사주소" onChange={handleCpAddress}/></div>
                                        <div class="mb-3"><input class="form-control" type="text" placeholder="대표자명" onChange={handleFullname}/></div>
                                        <div class="mb-3"><input class="form-control" type="text" name="mobileNo" placeholder="전화번호" onChange={handleTelno}/></div>
                                       
                                        {/* 인사담당자 */}
                                        {/* <div class="mb-3"><input class="form-control" type="text" placeholder="인사담당자명" onChange={handleRecruiterName}/></div>
                                        <div class="mb-3"><input class="form-control" type="text" placeholder="인사담당자 전화번호" onChange={handleRecruiterTelno}/></div>
                                        <div class="mb-3"><input class="form-control" type="text" placeholder="인사담당자 이메일" onChange={handleRecruiterEmail}/></div> */}
                                      
                                        <div class="mb-3"><input class="form-control" type="password" name="password" placeholder="비밀번호(8~16자의 영문, 숫자, 특수기호)" onChange={handlePassword}/></div>
                                        <div class="mb-3"><input class="form-control" type="password" name="password" placeholder="비밀번호 확인" onChange={handlePasswordRepeat}/></div>

                                        <div class="mb-3"><button class="btn btn-secondary d-block w-100" type="submit" onClick={doubleCheck}>중복확인</button></div>
                                        <div class="mb-3"><button class="btn btn-primary d-block w-100" type="submit" onClick={clickSubmit} disabled={!allowRegister}>가입하기</button></div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ToastMessage show={showToast} msg={msgToast} />
                    </div>
                </section>
            </main>
        </div>
    );
}